import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './AnimatedImageSlider.css';
import React from 'react';
import { canUseDOM, get } from '../../utils';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import InfiniteCarousel from './components/InfiniteCarousel';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import RouterLink from '../atoms/RouterLink';
var AnimatedImageSlider = function AnimatedImageSlider(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = useSitecoreContext();
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isVdsite = _React$useState2[0],
    setIsVdsite = _React$useState2[1];
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  if (!fields || !fields.data || !fields.data.item || fields.data.item.images.length < 14) {
    // for resolution 1920x1080 -> need to be at least 14 images (7 on each carousel (5 in center & 2 on the sides))
    // 1920\350 = 5.4 (5 center & 0.2 left, 0.2 right)
    console.info('AnimatedImageSlider component render skipped. No fields provided or provided less than 14 images');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [AnimatedImageSlider component is empty: please provide data source]");
    }
    return null;
  }
  var hasTitle = Boolean(get(fields, 'data.item.title.jss.value'));
  var title = get(fields, 'data.item.title.jss');
  var sliderLink = get(fields, 'data.item.sliderLink.jss.value.href');
  var initialImages = get(fields, 'data.item.images', []);
  var middleIndex = Math.ceil(initialImages.length / 2);
  var imagesLeft = initialImages.slice(0, middleIndex);
  var imagesRight = initialImages.slice(middleIndex);
  var moveRight = rtl ? "left" : "right";
  var moveLeft = rtl ? "right" : "left";
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement(ComponentsWrapper, null, hasTitle && /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: "h3 h__title",
    field: title
  })), /*#__PURE__*/React.createElement(RouterLink, {
    href: sliderLink,
    linktype: "external"
  }, /*#__PURE__*/React.createElement(InfiniteCarousel, {
    direction: moveLeft,
    images: imagesLeft,
    rtl: rtl
  }), /*#__PURE__*/React.createElement(InfiniteCarousel, {
    direction: moveRight,
    images: imagesRight,
    rtl: rtl
  })));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "ch060e2";
var rtlStyles = "rik5qw9";
var ltrStyles = "l1cd6jm6";
export default AnimatedImageSlider;